const DocumentLink = require('./document-link.js');

const documentLinkSelector = 'a[href*="//shared.portals.lumeris.io/"]';
const documentLinks = [];

async function init() {
    const links = document.querySelectorAll(documentLinkSelector);
    if (links.length === 0) {
        return false;
    }

    links.forEach((linkElement, linkIndex) => {
        documentLinks.push(new DocumentLink(linkIndex, linkElement));
    });

    for (const doc of documentLinks) {
        await doc.init();
    }
}

function onBodyMutation(mutations) {
    if (!Array.isArray(mutations)) {
        return;
    }

    mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
            // Check if node is an element to handle matches and queries
            if (node.nodeType === Node.ELEMENT_NODE) {
                if (node.matches(documentLinkSelector)) {
                    new DocumentLink(null, node).init();
                }
                node.querySelectorAll(documentLinkSelector).forEach((el) => {
                    new DocumentLink(null, el).init();
                });
            }
        });
    });
}

const observer = new MutationObserver(onBodyMutation);

const start = () => {
    if (document.body) {
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }
    init();
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
} else {
    start();
}